/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const NotificationEventType = {
    ClientProfilesExport: 1,
    NewClaimReviewMessage: 2,
    NewContractReviewMessage: 3,
    NewEmail: 4,
    CaseAccessRequested: 5
} as const;
export type NotificationEventType = typeof NotificationEventType[keyof typeof NotificationEventType];

